module.exports = __webpack_public_path__ + "static/media/Service-red.d11cef24.svg";